enum MEDIA_TYPE {
  IMAGE,
  DAMAGE,
  VIDEO
}

export default MEDIA_TYPE;
